import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Buffer } from "buffer";

// NOTE: IMPORT GLOBAL STYLES
import "antd/dist/reset.css";
import "./index.css";

import "@fontsource/public-sans";
import "@fontsource/public-sans/100.css";
import "@fontsource/public-sans/300.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/public-sans/900.css";

// NOTE: IMPORT PROVIDER
import { Provider } from "react-redux";
import { store } from "./store";

// NOTE: IMPORT TOAST NOTIFICATIONS
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// NOTE: IMPORT FONTS
import "@fontsource/public-sans";
import "@fontsource/public-sans/100.css";
import "@fontsource/public-sans/300.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/public-sans/900.css";

import "@fontsource/mona-sans";
import "@fontsource/mona-sans/300.css";
import "@fontsource/mona-sans/500.css";
import "@fontsource/mona-sans/700.css";
import "@fontsource/mona-sans/900.css";

window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <ToastContainer autoClose={2000} />
  </Provider>
);
